import { Component, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Department } from "@enums/department.enum";
import { ProductionStatus } from "@enums/productionStatus.enum";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { MarkOutsideProcessContractMovementAsReceivedDto } from "@interfaces/dto/markOutsideProcessContractMovementAsReceivedDto.interface";
import { MarkOutsideProcessContractMovementsAsSentDto } from "@interfaces/dto/markOutsideProcessContractMovementsAsSentDto.interface";
import { Site } from "@interfaces/site.interface";
import { OutsideProcessContractMovementService } from "@services/outsideProcessContractMovement.service";
import { SiteService } from "@services/site.service";
import { ToastService } from "angular-toastify";
import { DxDataGridComponent } from "devextreme-angular";

@Component({
	moduleId: module.id,
	selector: "outsideProcessContractMovements",
	styleUrls: ["outsideProcessContractMovements.css"],
	templateUrl: "outsideProcessContractMovements.html"
})
export class OpsPlanningOutsideProcessContractMovementAdminComponent {
	@ViewChild(DxDataGridComponent, { static: false }) dataGrid!: DxDataGridComponent
	changes: any = [];
	departments: any;
	editRowKey: any = null;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	headerTertiaryButtons: AdminHeaderButton[] = [];
	isLoading = true;
	opsPlanningMode = "Sending";
	opsPlanningModes = ["Sending", "Receiving"];
	outsideProcessContractMovements: any = [];
	popupAddButtonOptions: any;
	popupChangeMachineProductionStatus: { machineId: number, productionStatus: ProductionStatus } = { machineId: 0, productionStatus: ProductionStatus.Active };
	popupCloseButtonOptions: any = { onClick: () => this.closePopup(), text: "Close" };
	popupMarkOutsideProcessContractMovementAsReceivedDto: MarkOutsideProcessContractMovementAsReceivedDto = new MarkOutsideProcessContractMovementAsReceivedDto();
	popupMarkOutsideProcessContractMovementAsReceivedDtoMaximumToSend = 0;
	popupMarkOutsideProcessContractMovementsAsSentDto: MarkOutsideProcessContractMovementsAsSentDto = new MarkOutsideProcessContractMovementsAsSentDto();
	popupTitle = "Mark as Sent";
	popupVisible = false;
	quantityColumnCaption = "Qty to Send";
	selectedMovementIds: number[] = [];
	sites: Site[] = [];
	title = "Outside Process Movements to be Sent";

	constructor(private outsideProcessContractMovementService: OutsideProcessContractMovementService, private router: Router, private siteService: SiteService, private toastService: ToastService) {
		this.departments = GetPropertiesFromEnum(Department);
		this.getOutsideProcessMovements();
		this.getSites();

		this.isMovementNotSelected = this.isMovementNotSelected.bind(this);
		this.isMovementSelected = this.isMovementSelected.bind(this);
		this.markAsReceivedPopup = this.markAsReceivedPopup.bind(this);
		this.toggleMovementSelection = this.toggleMovementSelection.bind(this);
	}

	buildButtons() {
		this.headerTertiaryButtons = [
			{ icon: "fal fa-sync-alt", method: "getSendableOutsideProcessMovements", text: "" },
			{ method: "goToFirewall", text: "Firewall" },
			{ method: "goToManForMan", text: "Operator Plan" },
			{ method: "goToWorkforce", text: "Workforce" },
			{ method: "", style: "background-color: #10B981; color: white;", text: "OPM" }
		];

		this.headerSecondaryButtons = [];

		const filteredDepartments = this.departments.filter((d: { id: number; name: string; }) => (d.id > 0 && d.id < 55) || d.id == 70);
		filteredDepartments.forEach((fd: any) => {
			this.headerSecondaryButtons.push({ method: "goToDepartment-" + fd.id, text: fd.name });
		});

		this.headerPrimaryButtons = [];

		this.sites.forEach((site: any) => {
			this.headerPrimaryButtons.push({ method: "goToSite-" + site.id, text: site.name });
		});
	}

	changeOpsPlanningMode(e: any) {
		this.opsPlanningMode = e.value;
		this.getOutsideProcessMovements();
	}

	closePopup() {
		this.popupVisible = false;
	}

	getOutsideProcessMovements() {
		switch (this.opsPlanningMode) {
			case "Receiving":
				this.title = "Outside Process Movements to be Received";
				this.quantityColumnCaption = "Qty Sent";
				this.getReceivableOutsideProcessMovements();
				break;
			default:
				this.title = "Outside Process Movements to be Sent";
				this.quantityColumnCaption = "Qty to Send";
				this.getSendableOutsideProcessMovements();
				break;
		}
	}

	getReceivableOutsideProcessMovements() {
		this.isLoading = true;
		this.selectedMovementIds = [];
		this.outsideProcessContractMovements = [];
		this.outsideProcessContractMovementService.getReceivable()
			.subscribe(
				(res: any) => {
					this.outsideProcessContractMovements = res.response;
					this.isLoading = false;
				},
				(err) => {
					this.isLoading = false;
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	getSendableOutsideProcessMovements() {
		this.isLoading = true;
		this.selectedMovementIds = [];
		this.outsideProcessContractMovements = [];
		this.outsideProcessContractMovementService.getSendable()
			.subscribe(
				(res: any) => {
					this.outsideProcessContractMovements = res.response;
					this.isLoading = false;
				},
				(err) => {
					this.isLoading = false;
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	getSites() {
		this.siteService.getAll()
			.subscribe(
				(res: any) => {
					this.sites = res.response.items;
					this.buildButtons();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	goToDepartment(department: number) {
		this.router.navigate([`/admin/opsPlanning/department/${department}`]);
	}

	goToFirewall() {
		this.router.navigate(["/admin/opsPlanning/firewall"]);
	}

	goToManForMan() {
		this.router.navigate(["/admin/opsPlanning/operatorPlan"]);
	}

	goToOutsideProcessMovements() {
		this.router.navigate(["/admin/opsPlanning/outsideProcessContractMovements"]);
	}

	goToSite(site: number) {
		this.router.navigate([`/admin/opsPlanning/site/${site}`]);
	}

	goToWorkforce() {
		this.router.navigate(["/admin/opsPlanning/workforce"]);
	}

	headerButtonClick(method: string) {
		if (method.indexOf("-") > 0) {
			const split = method.split("-");
			// @ts-ignore // Required to be able to call the method directly from the variable
			this[split[0]](split[1]);
		}
		else {
			// @ts-ignore // Required to be able to call the method directly from the variable
			if (this[method]) this[method]();
		}
	}

	isMovementNotSelected(e: any) {
		return this.selectedMovementIds.includes(e.row.data.id) == false;
	}

	isMovementSelected(e: any) {
		return this.selectedMovementIds.includes(e.row.data.id) == true;
	}
	
	markAsReceived() {
		this.outsideProcessContractMovementService.markOutsideProcessContractMovementAsReceived(this.popupMarkOutsideProcessContractMovementAsReceivedDto)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated");
					this.getReceivableOutsideProcessMovements();
					this.closePopup();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}
	
	markAsReceivedPopup(e: any) {
		this.popupMarkOutsideProcessContractMovementAsReceivedDto = new MarkOutsideProcessContractMovementAsReceivedDto();
		this.popupMarkOutsideProcessContractMovementAsReceivedDto.dateReceived = new Date();
		this.popupMarkOutsideProcessContractMovementAsReceivedDto.outsideProcessContractMovementId = e.row.data.id;
		this.popupMarkOutsideProcessContractMovementAsReceivedDto.quantityReceived = e.row.data.quantitySent;
		this.popupMarkOutsideProcessContractMovementAsReceivedDtoMaximumToSend = e.row.data.quantitySent;
		this.popupTitle = "Mark as Received";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.markAsReceived(), text: "Mark Received", visible: true };
	}

	markAsSent() {
		this.outsideProcessContractMovementService.markOutsideProcessContractMovementsAsSent(this.popupMarkOutsideProcessContractMovementsAsSentDto)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated");
					this.getSendableOutsideProcessMovements();
					this.closePopup();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	markAsSentPopup() {
		if (this.selectedMovementIds.length < 1) {
			alert("You must select the movements to be sent.");
			return;
		}
		this.popupMarkOutsideProcessContractMovementsAsSentDto = new MarkOutsideProcessContractMovementsAsSentDto();
		this.popupMarkOutsideProcessContractMovementsAsSentDto.dateSent = new Date();
		this.popupMarkOutsideProcessContractMovementsAsSentDto.outsideProcessContractMovementIds = this.selectedMovementIds;
		this.popupMarkOutsideProcessContractMovementsAsSentDto.siteId = 1;
		this.popupTitle = "Mark as Sent";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.markAsSent(), text: "Mark Sent", visible: true };
	}

	toggleMovementSelection(e: any) {
		const movementId = e.row.data.id;
		if (this.selectedMovementIds.includes(movementId)) {
			this.selectedMovementIds.splice(this.selectedMovementIds.indexOf(movementId), 1);
		}
		else
		{
			this.selectedMovementIds.push(movementId);
		}
		this.dataGrid.instance.repaint();
		return false;
	}
}